// API Configuration
// NOTE: API base URL is configurable via REACT_APP_API_BASE_URL.
// Falls back to the staging API when the env var is absent.
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'https://apitest.tenantscore.co.ke';

export default API_BASE_URL;
